import { readonly } from 'vue'
import { createPrefixer } from '.'

const ROOT = 'ver-activo-fijo-pg' as const

export const RESOURCE_ACTIVO_FIJO_PG = 'Activo Fijo PG' as const
const rp = <T extends string>(mod: T): `${typeof ROOT}-${T}` => `${ROOT}-${mod}`
const pt = createPrefixer(ROOT, 'transacciones')
const pc = createPrefixer(ROOT, 'configuracion')
const pi = createPrefixer(ROOT, 'informes')
const pm = createPrefixer(ROOT, 'mantenimiento')
/**
 * Definición de permisos para Activos Fijos
 */
const permission = readonly({
    _root: ROOT,
    _resource: RESOURCE_ACTIVO_FIJO_PG,
    transacciones: {
        _perm: rp('transacciones'),
        crearActivoFijo: pt('crear-activo-fijo'),
        activacionActivoFijo: pt('activar-activo-fijo'),
        registroAvaluo: pt('registro-avaluo'),
        gestionActivosFijos: pt('gestion-activos-fijos'),
        liquidacionActivoFijo: pt('liquidacion-activo-fijo'),
        gestionAvaluos: pt('gestion-avaluos'),
        solicitarTransferencia: pt('solicitar-transferencia'),
        gestionSolicitudesTransferencia: pt('gestion-solicitudes-transferencia'),
        aprobarTransferencia: pt('aprobar-transferencia'),
    },
    configuracion: {
        _perm: rp('configuracion'),
        nivelAprobacionSolicitudTransferencia: pc('nivel-aprobacion-solicitud-transferencia'),
        permisosTiposActivoFijo: pc('permisos-tipos-activos-fijos'),
    },
    mantenimiento: {
        _perm: rp('mantenimiento'),
        tipoActivoFijo: pm('tipo-activo-fijo'),
        gestionPlantillaActivoFijo: pm('gestion-plantilla-activo-fijo'),
        plantillaActivoFijo: pm('plantilla-activo-fijo'),
        itemActivoFijo: pm('item-activo-fijo'),
    },
    informes: {
        _perm: rp('informes'),
        activoFijoXTipo: pi('activo-fijo-x-tipo'),
        activoFijoSinAltaContable: pi('activo-fijo-sin-alta-contable'),
        activoFijoConAltaContable: pi('activo-fijo-con-alta-contable'),
        depreciacionActivosFijos: pi('depreciacion-activos-fijos'),
        avaluosActivoFijo: pi('avaluos'),
    },
} as const)

export default permission
